import PermissionUtil from './PermissionUtil'

class AdvertiserAuthModel {
  constructor({ id, name, belong, permission }) {
    this.id = id
    this.name = name
    this.belong = belong
    this.permission = permission
    // UI操作する上で必要になるプロパティ
    this.isChanged = false
    this.agencyAuthModel = null
    this.insertionOrderAuths = []
  }
  setAgencyAuthModel(agencyAuthModel) {
    this.agencyAuthModel = agencyAuthModel
  }
  // inheritかどうかを判定する
  getInheritFlg() {
    if (this.permission === 'inherit') return true
    return false
  }
  // 自分自身がreadonly権限以上かどうか
  isMoreReadonly() {
    return PermissionUtil.isMoreReadonly(this.getPermission())
  }
  addInertionOrderAuth(inertionOrderAuth) {
    this.insertionOrderAuths.push(inertionOrderAuth)
  }
  // permissionがviewのときは、noneと返す
  getPermission() {
    if (this.permission === 'inherit') {
      return this.agencyAuthModel.getPermission()
    }
    if (this.permission === 'view') return 'none'
    return this.permission
  }

  /**
   * 自分自身の権限を変更する
   */
  setPermission(permission) {
    this.isChanged = true
    // permissionを適切な形にして代入する
    this.permission = this._calcAppropriatePermission(permission)
    // 変更を親に伝える
    if (this.agencyAuthModel !== null) {
      this.agencyAuthModel.notify()
    }
  }

  // 設定するpermissionについて、以下のいずれかの条件を満たす場合はviewに変更する
  _calcAppropriatePermission(permission) {
    // permissionを'none'に変更しようとしているときに
    if (permission === 'none') {
      // 変更しようとしているのが自分自身の権限 or 子要素にreadonly以上の子供がいる場合
      // 'view'に変更
      if (this.belong === true || this._hasReadonlyChildren()) return 'view'
    }
    return permission
  }

  /**
   *  readonly以上の子が1つでもあるどうかを判定する
   *  いる場合はtrue, いない場合はfalseを返す
   */
  _hasReadonlyChildren() {
    const ios = this.insertionOrderAuths.find((io, index, ios) => {
      return io.isMoreReadonly() === true
    })
    if (ios === undefined) return false
    return true
  }

  /**
   * IO Authが変更されたときに発火するメソッド
   *  IOにreadonly以上がいるときといないときで
   *  ADv Authの権限が変わる
   */
  notify() {
    // TODO: isChangedについて考える
    if (this._hasReadonlyChildren()) {
      // permissionがnoneで、子供にreadonly以上がいるときはviewになる
      if (this.getPermission() === 'none') this.permission = 'view'
    } else {
      // permissionがviewで、子供にreadonly以上がいないときはnoneになる
      if (this.permission === 'view') this.permission = 'none'
    }
  }
}

export default AdvertiserAuthModel
